/**
  申し込み用フォーム[求人情報詳細]コンポーネント
*/
<template>
  <div id="formJobDetails" class="form_group">
    <div class="rap1_boder" id="">
      <Section><h1 class="wrap_title pd_7">求人情報詳細</h1></Section>
      <Column class="pd3_parts formSharedComm">
        <label>必要想定求人票数</label>
        <div class="width60"><input type="text" inputmode="numeric" id="expectedJobPostCount" class="required form_txt"></div>
      </Column>
      <Column class="pd3_parts formSharedComm">
        <label>職種</label>
        <div class="width60"><input type="text" id="jobType" class="required form_txt"></div>
      </Column>
      <Column class="pd3_parts formSharedComm">
        <label>雇用形態</label>
        <div class="width60"><input type="text" id="employmentType" class="required form_txt"></div>
      </Column>
      <Column class="pd3_parts formSharedComm">
        <label>勤務地</label>
        <div class="width60"><input type="text" id="workLocation" class="required form_txt"></div>
      </Column>
      <Column class="pd3_parts formSharedComm">
        <label>営業時に話をしたお客様の求人サイトURL</label>
        <div class="width60"><input type="text" id="customerJobSiteUrl" class=" form_txt"></div>
      </Column>
    </div>
  </div>
</template>


<script>
import { defineComponent } from 'vue'

// コンポーネントを読み込む
import Variables from '../../../molecules/variables.vue';
import Choices from '../../../molecules/choices.vue';
import Box from '../../../molecules/box.vue';
import Section from '../../../molecules/section.vue';
import Column from '../../../molecules/column.vue';
import Group from '../../../molecules/group.vue';
import Flex from '../../../molecules/flex.vue';
import Block from '../../../molecules/block.vue';

import Description from '../../../atoms/description.vue';
import Label from '../../../atoms/label.vue';
import Input from '../../../atoms/input.vue';
import Select from '../../../atoms/select.vue';
import Textarea from '../../../atoms/textarea.vue';
import Button from '../../../atoms/button.vue';
import IconAdd from '../../../atoms/icon-add.vue';
import IconRemove from '../../../atoms/icon-remove.vue';

export default defineComponent({
  name: 'formApplicationJobDetails',

  components: {
    Variables,
    Choices,
    Box,
    Section,
    Column,
    Group,
    Flex,
    Block,

    Description,
    Label,
    Input,
    Select,
    Textarea,
    Button,
    IconAdd,
    IconRemove,
  },

  methods: {
  },

  mounted() {
  },

  setup(_, context) {
    return {}
  }

})
</script>
